import EastWoodsAreForever from "../assets/files/natural_areas/east_woods_are_forever.pdf";
import Nelson from "../assets/files/natural_areas/nelson_2017_natural_areas_endure_transformation.pdf";
import PreservationNews from "../assets/files/natural_areas/preservation_news.pdf";
import SustainingOurNaturalHeritage from "../assets/files/natural_areas/sustaining_our_natural_heritage.pdf";
import Hosah from "../assets/files/natural_areas/hosah_final_report.pdf";

interface EssayType {
  name: string;
  file: string;
}

export const NaturalAreasList: EssayType[] = [
  {
    name: "East Woods Are Forever",
    file: EastWoodsAreForever,
  },
  {
    name: "Nelson 2017 Natural Areas Endure Transformation",
    file: Nelson,
  },
  {
    name: "Preservation News",
    file: PreservationNews,
  },
  {
    name: "Sustaining Our Natural Heritage",
    file: SustainingOurNaturalHeritage,
  },
  {
    name: "Vegetation of Hosah Park",
    file: Hosah,
  },
];

export default NaturalAreasList;
export type { EssayType };
